import {
  Box,
  Button,
  Flex,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { ReactComponent as VenngageLogoIcon } from 'assets/icons/venngage_logo.svg';
import { PRIVATELINK_DMCA_POLICY_LINK, PRIVATELINK_REPORT_LINK, VENNGAGE_HOME_PAGE } from 'constants/links';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

const logoStyle: CSSProperties = {
  width: '14px',
  height: '14px',
  cursor: 'pointer',
  color: 'white',
};

export const LegalNote = () => {
  const { t } = useTranslation('responsive_link');

  return (
    <Flex px={2} w='full' py='2px' bg='black' fontSize='xs' color='white'>
      <Box zIndex={'popover'}>
        <Popover placement='top-start' closeOnBlur isLazy>
          {({ onClose }) => (
            <>
              <PopoverTrigger>
                <Text as='button'>{t('content-policy')}</Text>
              </PopoverTrigger>
              <LegalPopoverContent onClose={onClose} />
            </>
          )}
        </Popover>
      </Box>
      <Flex
        ml='auto'
        gap={0.5}
        align='center'
        cursor='pointer'
        _hover={{ textDecor: 'underline' }}
        href={VENNGAGE_HOME_PAGE}
        as='a'
      >
        <Text display={{ base: 'none', sm: 'block' }}>{t('created')}</Text>
        <VenngageLogoIcon aria-hidden='true' style={logoStyle} />
        <Text>VENNGAGE</Text>
      </Flex>
    </Flex>
  );
};

const LegalPopoverContent = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('responsive_link');

  return (
    <PopoverContent p={4} zIndex={'popover'} color='font.500'>
      <PopoverArrow />
      <Box zIndex={1000} position='relative'>
        <PopoverHeader p={0} mb={4} fontWeight='bold' fontSize='sm' border='0'>
          {t('content-policy')}
        </PopoverHeader>

        <PopoverBody p={0}>
          <Text fontSize='xs'>
            {t('legal-1')}{' '}
            <Link textDecor='underline' href={PRIVATELINK_DMCA_POLICY_LINK} isExternal>
              {t('legal-2')}
            </Link>{' '}
            {t('legal-3')}
          </Text>
          <Flex mt={4} justifyContent='flex-end' gap={1}>
            <Button onClick={onClose} fontWeight='normal' size='xs' fontSize='xs' variant='ghost'>
              {t('close')}
            </Button>
            <Link
              fontWeight='medium'
              display='flex'
              flexDir='row'
              gap={1}
              justifyContent='center'
              alignItems='center'
              href={PRIVATELINK_REPORT_LINK}
              isExternal
              fontSize='xs'
              color='red.600'
            >
              {t('report')}
            </Link>
          </Flex>
        </PopoverBody>
      </Box>
    </PopoverContent>
  );
};
